import Vue from 'vue';
import VueI18n from '../i18n/i18n';

class MessageDialogHelper {

  displayDialogConfirm(title, text, callback) {
    Vue.prototype.$vs.dialog({
      type: "confirm",
      color: "primary",
      title: title,
      text: text,
      accept: () => {
        callback('accept');
      },
      acceptText: 'OK',
      cancelText: VueI18n.t('DIALOG_MESSAGES').CancelText,
    });
  }
  displayDialogAccept(title, text, callback) {
    Vue.prototype.$vs.dialog({
      color: "primary",
      title: title,
      text: text,
      accept: () => {
        callback('accept');
      },
      acceptText: 'OK',
      cancelText: VueI18n.t('DIALOG_MESSAGES').CancelText,
    });
  }
  displayDialogAcceptCancel(title, text, callback) {
    Vue.prototype.$vs.dialog({
      color: "primary",
      title: title,
      text: text,
      accept: () => {
        callback('accept');
      },
      cancel: () => {
        callback('cancel');
      },
      acceptText: 'OK',
      cancelText: VueI18n.t('DIALOG_MESSAGES').CancelText,
    });
  }

  displayUserRightsMessage(itemName, callback) {
    Vue.prototype.$vs.dialog({
      type: "confirm",
      color: "primary",
      title: VueI18n.t('DIALOG_MESSAGES').Title,
      text: `${VueI18n.t('DIALOG_MESSAGES').UserRightsText} ${itemName}.`,
      accept: () => {
        callback();
      },
      acceptText: VueI18n.t('DIALOG_MESSAGES').AcceptText,
      cancelText: VueI18n.t('DIALOG_MESSAGES').CancelText,
    });
  }

  displayGetMoreQuestionMessage(callback) {
    Vue.prototype.$vs.dialog({
      type: "confirm",
      color: "primary",
      title: VueI18n.t('DIALOG_MESSAGES').Title,
      text: VueI18n.t('DIALOG_MESSAGES').GetMoreQuestionsText,
      accept: () => {
        callback();
      },
      acceptText: VueI18n.t('DIALOG_MESSAGES').AcceptText,
      cancelText: VueI18n.t('DIALOG_MESSAGES').CancelText,
    });
  }

  displayEditAccountDataMessage(callback) {
    Vue.prototype.$vs.dialog({
      type: "confirm",
      color: "primary",
      title: VueI18n.t('DIALOG_MESSAGES').Title,
      text: VueI18n.t('DIALOG_MESSAGES').AccountEditDataText,
      accept: () => {
        callback();
      },
      acceptText: VueI18n.t('DIALOG_MESSAGES').AcceptText,
      cancelText: VueI18n.t('DIALOG_MESSAGES').CancelText,
    });
  }

  displayPlatformTour(callback) {
    Vue.prototype.$vs.dialog({
      type: "confirm",
      color: "primary",
      title: VueI18n.t('DIALOG_MESSAGES').Title,
      text: VueI18n.t('DIALOG_MESSAGES').PlatformTourText,
      accept: () => {
        callback('accept');
      },
      cancel: () => {
        callback('cancel');
      },
      acceptText: VueI18n.t('DIALOG_MESSAGES').StartText,
      cancelText: VueI18n.t('DIALOG_MESSAGES').NotDisplatText,
    });
  }

  displaySentRequestDemo(callback) {
    Vue.prototype.$vs.dialog({
      color: "primary",
      title: VueI18n.t('DIALOG_MESSAGES').Title,
      text: VueI18n.t('DIALOG_MESSAGES').SentRequestDemo,
      accept: () => {
        callback('accept');
      },
      acceptText: VueI18n.t('DIALOG_MESSAGES').CancelText,
      cancelText: VueI18n.t('DIALOG_MESSAGES').CancelText,
    });
  }

  displayChangePasswordSuccess(callback) {
    Vue.prototype.$vs.dialog({
      color: "primary",
      title: VueI18n.t('CHANGE_PASSWORD').Notify_Success_Title,
      text: VueI18n.t('CHANGE_PASSWORD').Notify_Success_Message,
      accept: () => {
        callback('accept');
      },
      acceptText: VueI18n.t('DIALOG_MESSAGES').CancelText,
      cancelText: VueI18n.t('DIALOG_MESSAGES').CancelText,
    });
  }

  displayDialogConfirmWithText(title, text, confirmText, callback) {
    Vue.prototype.$vs.dialog({
      type: "confirm",
      color: "primary",
      title: title,
      text: text,
      accept: () => {
        callback('accept');
      },
      acceptText: confirmText,
    });
  }
  displayDialogConfirmCancelWithText(title, text, confirmText, cancelText, callback) {
    Vue.prototype.$vs.dialog({
      type: "confirm",
      color: "primary",
      title: title,
      text: text,
      accept: () => {
        callback('accept');
      },
      cancel: () => {
        callback('cancel');
      },
      acceptText: confirmText,
      cancelText: cancelText,
      css: {
        zIndex: '9999998'
      }
    });
  }

}

export default new MessageDialogHelper();
